<template>
  <div>
    <InputPolynominal :f="f" :g="g" @finish="start"></InputPolynominal>
    <EuclidPolynominal v-if="valid" :f="f" :g="g"></EuclidPolynominal>
  </div>
</template>

<script>
import { Polynominal } from '@/lib/poly.js';
import InputPolynominal from '@/components/InputPolynominal.vue'
import EuclidPolynominal from '@/components/EuclidPolynominal.vue'


export default {
  name: 'Poly',
  components: {
    InputPolynominal,
    EuclidPolynominal
  },
  data: function(){
    return {
      f: new Polynominal(),
      g: new Polynominal(),
      valid: false,
    }
  },
  methods: {
    start(){
      this.valid = false;
      this.$nextTick( () => {this.valid = true;} );
    }
  },
}
</script>

<style scoped>
</style>
